export default "__VITE_ASSET__fb589889__"